// Percorso file: src/utils/stagione.js
//
// L'ANNATA — sede unica del metro con cui il browser legge un anno.
//
// ⚠️ MODULO PURO, E DEVE RESTARLO: nessun React, nessun hook, nessun import
// di AuthContext, nessun import di alcun genere. Non è un vezzo: `AuthContext`
// importa questo file (è lui a normalizzare `operatingSeason` e
// `enrollmentSeason` per tutta l'app), quindi qualunque import in senso
// contrario aprirebbe un ciclo proprio sul codice d'ingresso.
//
// ⚠️ L'ANNO NON È MATERIA DI SQUADRE, e per questo sta qui e non in
// `utils/squadre.js`: lo leggono anche gli anni della PERSONA
// (`annateDeiDati`, `alertSeasons`, `playFootballSeasons`, `renewedSeason`)
// e la cassettina della stagione. Metterlo nel modulo delle squadre
// costringerebbe AuthContext a importare le squadre per normalizzare un anno.

/**
 * L'anno come intero, oppure `null` se il valore non è un anno.
 *
 * ⚠️ È LO STESSO METRO DEL BACKEND (`annoTollerante`, server.js), ripetuto
 * qui perché il browser non condivide codice col server, e perché il
 * confronto deve avvenire fra NUMERI: i documenti storici scrivono "2026"
 * (stringa) dove i nuovi scrivono 2026 (numero), e un `===` crudo fra i due
 * tipi farebbe sparire in silenzio le tessere vecchie.
 *
 * ⚠️ SEDE UNICA (cantiere «lettore unico»). Il corpo viveva un tempo in
 * più copie identiche, ognuna delle quali dichiarava per iscritto di essere
 * una copia e rimandava a una sede condivisa futura: le sette assorbite dal
 * cantiere «lettore unico» — `UsersList`, `TeamAssignment`,
 * `UserContextManager` (`annoDiUcm`), `HomeParent`, `HomePlayer`,
 * `MemberProfileModal` e `AuthContext` (`annoDiStagione`) — e altre due
 * assorbite dopo, in 6efb79d: `SeasonManagement` (`annoDaRisposta`) ed
 * `EnrolNextSeason` (`annoTollerante`), che oggi importano da qui col nome
 * di sempre. Questa è quella sede: il corpo qui sotto è quello delle copie,
 * invariato.
 *
 * @param {*} valore il valore grezzo, in qualunque grafia
 * @returns {number|null}
 */
export const annoDiLista = (valore) => {
  const grafiaAmmessa =
    typeof valore === "number" ||
    (typeof valore === "string" && valore.trim() !== "");

  const anno = Number(valore);

  return grafiaAmmessa && Number.isInteger(anno) ? anno : null;
};
